const ROLE = Object.freeze({
    USER: 'user',
    ASSISTANT: 'assistant',
});

export const NOISE_REDUCTION = Object.freeze({
    NEAR: 'near_field',
    FAR: 'far_field',
});

export const VOICE = Object.freeze({
    ALLOY: 'alloy',
    ASH: 'ash',
    BALLAD: 'ballad',
    CORAL: 'coral',
    ECHO: 'echo',
    SAGE: 'sage',
    SHIMMER: 'shimmer',
    VERSE: 'verse',
    MARIN: 'marin',
    CEDA: 'ceda',
});

export const SUPPORTED_FILES_EXT = Object.freeze({
    C: '.c',
    CS: '.cs',
    CPP: '.cpp',
    DOC: '.doc',
    DOCX: '.docx',
    HTML: '.html',
    JAVA: '.java',
    JSON: '.json',
    MD: '.md',
    PDF: '.pdf',
    PHP: '.php',
    PPTX: '.pptx',
    PY: '.py',
    RB: '.rb',
    TEX: '.tex',
    TXT: '.txt',
    CSS: '.css',
    JS: '.js',
    SH: '.sh',
    TS: '.ts',
});

export const AI_CONVERSATION_TYPE = Object.freeze({
    CALL: 'Call',
    WEB_CHAT: 'Web Chat',
});

export const AGENT_TYPE = Object.freeze({
    CRM_AGENT: 'CRM Agent',
    COLLECTOR: 'Collector',
});

export default ROLE;
